import { render, staticRenderFns } from "./wishWall.vue?vue&type=template&id=baedae1c"
import script from "./wishWall.vue?vue&type=script&lang=js"
export * from "./wishWall.vue?vue&type=script&lang=js"
import style0 from "./wishWall.vue?vue&type=style&index=0&id=baedae1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports